(function () {
  var players = {};
  var iframeIdCounter = 0;
  var iframeIdPrefix = '_yt_iframe_youtubeapi_';

  function maintainOnlySinglePlayback(id) {
    if (!id) {
      return;
    }

    for (var playerId in players) {
      if (players.hasOwnProperty(playerId) && playerId !== id) {
        var player = jQuery('#' + playerId).data('player');
        if (player && typeof player.pauseVideo === 'function') {
          player.pauseVideo();
        }
      }
    }
  }

  function initializeYouTubePlayers() {
    if (typeof window.YoutubeApiPlayers !== 'undefined') {
      var stateChange = function (e) {
        var $ = jQuery;
        var entry = $(e.target.a)
          .closest('article.tile')
          .find('.entry-content');

        if (e.data === YT.PlayerState.PLAYING) {
          var elem = e.target.a || e.target.h;
          if (elem && elem.getAttribute('id')) {
            maintainOnlySinglePlayback(elem.getAttribute('id'));
          }
          // playing
          entry.addClass('hidden');
        } else if (e.data === YT.PlayerState.PAUSED) {
          // stopped
          entry.removeClass('hidden');
        }
      };

      var ready = function (e) {
        jQuery(e.target.a).trigger('youtubeApi:ready', [e]);
      };

      var mute = function (e) {
        e.target.mute();
        ready(e);
      };

      for (var i = 0; i < window.YoutubeApiPlayers.length; i++) {
        var player = window.YoutubeApiPlayers[i];

        var options = {
          videoId: player.videoId,
          host: 'https://www.youtube-nocookie.com',
          // sizes overridden by css
          width: 1,
          height: 1,
          playerVars: {
            autoplay: player.autoplay,
            controls: 1,
            showinfo: 0,
            modestbranding: 0,
            loop: 0,
            fs: 1,
            cc_load_policy: 0,
            iv_load_policy: 3,
            autohide: 1,
          },
          events: {
            onStateChange: stateChange,
            onReady: ready,
          },
        };

        if (player.mute) {
          options.events.onReady = mute;
        }

        var ytPlayer = new YT.Player(player.domID, options);
        players[player.domID] = ytPlayer;

        // Add the player to the iframe element so we can use it elsewhere
        // Fire a trigger so other plugins know when the video initializes
        jQuery('#' + player.domID)
          .data('player', ytPlayer)
          .trigger('youtubeApi:initialized', [ytPlayer, player, options]);
      }
    }

    // Loop over all other youtube iframes and register the JS api on these as well
    jQuery(
      'iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="youtube-nocookie.com"]'
    ).each(function (index, iframe) {
      var domId = iframe.getAttribute('id');
      if (!domId) {
        domId = iframeIdPrefix + iframeIdCounter++;
        iframe.setAttribute('id', domId);
      }

      var ytPlayer = new YT.Player(iframe, {
        events: {
          onStateChange: function (e) {
            if (e.data === YT.PlayerState.PLAYING) {
              // playing
              if (e.target.h && e.target.h.getAttribute('id')) {
                maintainOnlySinglePlayback(e.target.h.getAttribute('id'));
              }
            }
          },
        },
      });

      jQuery(iframe).data('player', ytPlayer);
      players[domId] = ytPlayer;
    });
  }

  if (document.youTubeIframeApiLoaded) {
    initializeYouTubePlayers();
  } else {
    $(document).on('youTubeIframeApiLoaded', initializeYouTubePlayers);
  }
})();
